import { render } from "./MultiPublisherYieldTable.vue?vue&type=template&id=3685cc4b&scoped=true"
import script from "./MultiPublisherYieldTable.vue?vue&type=script&lang=js"
export * from "./MultiPublisherYieldTable.vue?vue&type=script&lang=js"

import "./MultiPublisherYieldTable.vue?vue&type=style&index=0&id=3685cc4b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3685cc4b"]])

export default __exports__